import { initMercadoPago } from "@mercadopago/sdk-react";
import { Payment } from "@mercadopago/sdk-react";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import ComponentStatusScreen from "./ComponentStatusScreen";
import { getAuth } from "../../../../../app/modules/auth";
import { ThemeModeComponent } from "../../../../assets/ts/layout";
import { toastfy } from "../../../../partials/toast/Toast";
import { showErrorMessage } from "../../../../helpers/MessagesHelper";

const apiPublic = "TEST-238b31e5-ebb9-423e-81b7-c3ef4f00979b";
initMercadoPago(apiPublic);

var selectedTheme = ThemeModeComponent.getMode();

function ComponentBricks({ itemId, itemValue, setDashboardUpdate }) {
  const [responsePaymentPix, setResponsePaymentPix] = useState(false);
  const [statusPayment, setStatusPayment] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const initialization = {
    amount: itemValue,
    player: {
      firstName: "",
      lastName: "",
      email: "",
    },
  };

  const customization = {
    visual: {
      style: {
        theme: "bootstrap",
        customVariables: {
          textPrimaryColor: selectedTheme,
          formBackgroundColor: selectedTheme,
          inputBackgroundColor: selectedTheme,
        },
      },
    },
    paymentMethods: {
      ticket: "all",
    },
  };

  const { userId, contractId } = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiToken = getAuth();
  const token = apiToken?.api_token;
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const onSubmit = async ({ formData }) => {
    return new Promise((resolve, reject) => {
      fetch(
        `${apiUrl}/users/${userId}/contracts/${contractId}/charges/${itemId}/payments`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(formData),
        }
      )
        .then((response) => response.json())
        .then((response) => {
          toastfy("success", "Operação bem sucedida!");

          setResponsePaymentPix(response);
          setStatusPayment(
            response.notifications[response.notifications.length - 1]
          );
          setDashboardUpdate(true);
          resolve();
        })
        .catch((error) => {
          showErrorMessage(
            error?.response?.data?.error?.statusCode,
            error?.response?.data?.error?.message
          );
          setDashboardUpdate(true);
          reject();
        });
    });
  };

  const onError = async (error) => {
    showErrorMessage(
      error?.response?.data?.error?.statusCode,
      error?.response?.data?.error?.message
    );
  };

  const onReady = async () => {
    setIsLoading(false);
  };

  return (
    <div className="d-flex justify-content-center ">
      <div className="text-center mt-5">
        {isLoading ? (
          <Spinner animation="border" role="status">
            <span className="sr-only">Carregando...</span>
          </Spinner>
        ) : null}
      </div>

      {!responsePaymentPix && (
        <Payment
          initialization={initialization}
          customization={customization}
          onSubmit={onSubmit}
          onReady={onReady}
          onError={onError}
        />
      )}

      {statusPayment && (
        <ComponentStatusScreen payment_key={statusPayment.payment_key} />
      )}
    </div>
  );
}

export default ComponentBricks;
